<template>
<div>
    <b-form @submit="saveQuestionList">
        <div class="box box-primary">
            <div class="box-header">
                <h3 class="box-title">{{$t('survey.title')}}</h3>
            </div>
            <div class="box-body">
                <div class="row">
                  <div class="col-md-6">
                        <div class="form-group">
                          <label for="survey_name">{{$t('survey.survey_name')}}</label>
                          <b-form-input
                            type="text"
                            class="form-control"
                            v-model="surveydata.survey_name"
                            :placeholder="$t('survey.survey_name')"
                            :disabled="this.surveydata.id != 0"
                          />
                        </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="created_by">{{$t('survey.created_by')}}</label>
                      <input
                          v-model="surveydata.created_by"
                          type="text"
                          class="form-control"
                          :placeholder="$t('survey.created_by')"
                          disabled
                      >
                    </div>
                  </div>
                </div>

                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group">
                          <label for="type_of_question_list">{{$t('survey.type_of_question_code')}}</label>
                          <!-- <b-form-select
                              :options="type_of_question_list"
                              v-model="surveydata.type_of_question_code"
                              class="form-control"
                          /> -->
                          <select v-model="surveydata.type_of_question_code" class="form-control" id="shirt_size">
                            <option
                              v-for="question in type_of_question_list"
                              :key="question.id"
                              :value="question.value"
                            >{{$t(question.text)}}</option>
                          </select>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                          <label for="date_of_survey">{{$t('survey.date_of_survey')}}</label>
                          <date-picker
                            class="form-control"
                            v-model="surveydata.date_of_survey"
                            :config="options"
                          ></date-picker>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-12">
                        <div class="form-group">
                          <label for="country">{{$t('survey.question_details')}}</label>
                          <b-form-textarea
                            type="text"
                            class="form-control"
                            v-model="surveydata.question_details"
                            rows="8"
                            :placeholder="$t('survey.question_details')" />
                        </div>
                    </div>
                </div>
                </div>
                    <b-button ref="formsubmitbutton" type="submit" variant="primary" style="display: none;">{{$t('common.submit')}}</b-button>
                </div>
    </b-form>
    <!-- /.box-body -->
    <div class="box-footer">
        <button
        type="button"
        class="btn btn-labeled btn-danger"
        @click="onCancel"
        style="margin-right: 5px;"
      >
        <span class="btn-label">
          <i class="glyphicon glyphicon-remove"></i>
        </span>
        {{$t('common.cancel')}}
      </button>
        <button
        type="button"
        class="btn btn-labeled btn-success pull-right"
        @click="onSave"
        style="margin-right: 5px;"
      >
        <span class="btn-label">
          <i class="glyphicon glyphicon-ok"></i>
        </span>
        {{$t('common.save')}}
      </button>
    </div>

    <lte-core-alert v-for="snackbar in GET_SNACK_BAR" :key="snackbar.id" :item="snackbar"></lte-core-alert>
    <router-view></router-view>

    <!-- Inform modal -->
    <div class="modal modal-default" id="inform_modal">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
                    <h4 class="modal-title">{{$t('customer.inform_modal[0].title')}}</h4>
                </div>
                <div class="modal-body">
                    <h5 class="modal-title">{{$t(modal_title)}}</h5>
                </div>
                <div class="modal-footer">
                    <button
          type="button"
          class="btn btn-default pull-right"
          data-dismiss="modal"
        >{{$t('customer.inform_modal[0].modal_btn[0].close')}}</button>
                </div>
            </div>
            <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
    </div>
    <!-- /.modal -->
</div>
</template>

<script>
import LTECoreAlert from "@/components/LTESnackBar.vue";
import datePicker from "vue-bootstrap-datetimepicker";
import moment from "moment";
import { mapGetters, mapActions } from "vuex";
import constantData from "@/lib/constantsData"
import utils from '@/lib/utils'

export default {
    name: "MobileAdd",
    props: {
        survey_id: {
            type: Number,
            default: () => {
                return 0
            }
        },
        callback: {
            type: String
        },

    },
    data() {
        return {
            timeCurrent: "2019-01-16T06:00:00Z",
            surveydata: {
              id: 0,
              date_of_survey: null,
              created_by: "",
              survey_name: "",
              type_of_question_code: null,
              question_details: "",
            },
            options: {
              format: "DD-MM-YYYY",
              useCurrent: false,
              minDate: moment(),
            },
            type_of_question_list: constantData.questionType,
            modal_title: "",
            test: 0
        };
    },

    watch: {
        SURVEYQUESTION_DETAIL_DATA: function () {
          this.surveydata.date_of_survey = utils.formatSqlDate(this.SURVEYQUESTION_DETAIL_DATA.date_of_survey, null, "DD-MM-YYYY");
          this.surveydata.created_by = this.SURVEYQUESTION_DETAIL_DATA.created_by;
          this.surveydata.survey_name = this.SURVEYQUESTION_DETAIL_DATA.survey_name;
          this.surveydata.type_of_question_code = this.SURVEYQUESTION_DETAIL_DATA.type_of_question_code;
          this.surveydata.question_details = this.SURVEYQUESTION_DETAIL_DATA.question_details;
          this.surveydata.survey = this.SURVEYQUESTION_DETAIL_DATA.survey;
        },
    },

    computed: {
        ...mapGetters([
            "GET_SNACK_BAR",
            "SURVEYQUESTION_DETAIL_DATA",
            "GET_ACCOUNT_DATA"
        ]),
        // getAccountFullName: function() {
        //   return `${this.GET_ACCOUNT_DATA.lastname} ${this.GET_ACCOUNT_DATA.firstname}`;
        // },
        getAccountID: function() {
          return this.GET_ACCOUNT_DATA.id;
        }
    },

    methods: {
        ...mapActions([
            "ERROR_TOAST",
            "SUCCESS_TOAST",
            "ADD_SURVEYQUESTION",
            "GET_SURVEYQUESTION_DETAIL",
            "UPDATE_SURVEYQUESTION",
            "ON_SHOW_TOAST"
        ]),

        callBackToList: function(){
            let name = "Question"
            if (typeof(this.callback) !== 'undefined'){
                name = this.callback
            }
            this.$router.push({
                name: name
            });
        },
        onCancel: function () {
            this.callBackToList()
        },
        clearInput: function() {
          this.surveydata.question_details = "";
          this.surveydata.id = 0;
        },
        validateData: function () {
            let validatedResult = "OK";
            for (let key in this.surveydata) {
                if (this.surveydata[key] === null || this.surveydata[key] === "") {
                  validatedResult = "Xin vui lòng nhập/chọn " + this.$t('survey.' + key);
                  break;
                } else {
                  //
                }
            }
            return validatedResult;
        },
        saveQuestionList: function (event) {
            event.preventDefault();
            let result = this.validateData();

            if (result == "OK") {
                let data = {
                    date_of_survey: utils.formatSqlDate(this.surveydata.date_of_survey, "DD-MM-YYYY", "YYYY-MM-DD HH:mm:ss"),
                    created_by: this.getAccountID,
                    survey: this.surveydata.survey,
                    survey_name: this.surveydata.survey_name,
                    question: this.surveydata.id,
                    type_of_question_code: this.surveydata.type_of_question_code,
                    question_details: this.surveydata.question_details,
                    id: this.surveydata.id
                };

                if (parseInt(this.surveydata.id) == 0) {
                    this.ADD_SURVEYQUESTION(data)
                      .then(
                          function (res) {
                            this.SUCCESS_TOAST();
                            this.clearInput();
                        }.bind(this)
                      )
                      .catch(
                          function (error) {
                            this.ON_SHOW_TOAST({
                                message: error.response.data.message,
                                styleType: "danger"
                            })
                          }.bind(this)
                      );
                } else {
                    this.UPDATE_SURVEYQUESTION(data)
                      .then(
                        function (res) {
                          this.SUCCESS_TOAST();
                          this.callBackToList()
                        }.bind(this)
                      )
                      .catch(
                        function (error) {
                            this.ON_SHOW_TOAST({
                              message: error.response.data.message,
                              styleType: "danger"
                          })
                        }.bind(this)
                      );
                }
            } else {
                this.ON_SHOW_TOAST({
                    message: result,
                    styleType: "danger"
                })
            }
        },
        onSave() {
            this.$refs.formsubmitbutton.click();
        },
        showInformmodal: function (title) {
            this.modal_title = title;
            $("#inform_modal").modal("show");
        },
    },
    async mounted() {
      let id = this.$route.params.id;

      if (parseInt(id) !== 0) {
        this.surveydata.id = id;
        await this.GET_SURVEYQUESTION_DETAIL({ id: id });
      } else {
        this.surveydata.created_by = await this.GET_ACCOUNT_DATA.lastname + " " + await this.GET_ACCOUNT_DATA.firstname;
      }
    },

    created(){

    },

    components: {
        "lte-core-alert": LTECoreAlert,
        "date-picker": datePicker,
    }
};
</script>

<style lang="" scoped>
@media (min-width: 768px) {
    .modal-dialog {
        width: 800px;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/Mobile/MobileAdd.vue